import { useState, useEffect, useContext } from 'react'
import { fillGoogleReverseGeocode, LatLngReverse } from '../api/google-integration'
import TripsContext from '../contexts/TripsContext'
import { filterHardwareData } from '../utils'

export const useReverseGeocode = (): any => {
    const [loadingReverseGeocoding, setLoadingReverseGeocoding] = useState(false)
    const { reverseGeocoding, setReverseGeocoding } = useContext(TripsContext)

    useEffect(() => {
        setLoadingReverseGeocoding(false)
    }, [reverseGeocoding])

    const fillGoogleReverseLatLng = async (latLngs: any[] = []) => {
        const result = await fillGoogleReverseGeocode(reverseGeocoding, latLngs)
        setReverseGeocoding(result)
    }

    const fillGoogleReverseGeocodeAux = async (vehicles, hardwareData = {}) => {
        setLoadingReverseGeocoding(true)
        const hw = filterHardwareData(vehicles, hardwareData)

        if (Object.keys(hw).length === 0) return

        const latLngsReverse: LatLngReverse[] = []

        Object.keys(hw).forEach(key => {
            const { lat, lng } = hw[key]
            latLngsReverse.push({ lat, lng })
        })

        fillGoogleReverseLatLng(latLngsReverse)
    }

    return { loadingReverseGeocoding, fillGoogleReverseGeocodeAux, fillGoogleReverseLatLng }
}
